import { Section } from '../blocks/layout'
import { ProductRail } from '../blocks/Rail'
import type { Model } from '../types'

function Discovery({ model, name }: { model: Model; name: keyof Model['discoveryRails'] }) {
  const rail = model.discoveryRails[name]
  if (!rail.products.length) return null
  return <Section aria={rail.title} v2={name} tone="peach"><ProductRail {...rail} level={2} /></Section>
}
export const BeforeParts = ({ model }: { model: Model }) => <Discovery model={model} name="panelReadyFridges" />
export const BeforeTools = ({ model }: { model: Model }) => <Discovery model={model} name="drawerFridges" />
export const BeforeFaq = ({ model }: { model: Model }) => <Discovery model={model} name="freezerlessFridges" />
export const BeforeSocial = ({ model }: { model: Model }) => <Discovery model={model} name="portableFridges" />
